/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyticsUserSchema
 */
export interface AnalyticsUserSchema {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsUserSchema
     */
    username: string;
}

/**
 * Check if a given object implements the AnalyticsUserSchema interface.
 */
export function instanceOfAnalyticsUserSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function AnalyticsUserSchemaFromJSON(json: any): AnalyticsUserSchema {
    return AnalyticsUserSchemaFromJSONTyped(json, false);
}

export function AnalyticsUserSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyticsUserSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function AnalyticsUserSchemaToJSON(value?: AnalyticsUserSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
    };
}

